import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { Circle } from "rc-progress";
AOS.init();

const skills = [
  {
    name: "Javascript",
    percentage: 75,
  },
  {
    name: "Tailwind",
    percentage: 80,
  },
  {
    name: "React",
    percentage: 80,
  },
  {
    name: "R-Native",
    percentage: 70,
  },
  {
    name: "Php",
    percentage: 70,
  },
  {
    name: "Laravel",
    percentage: 75,
  },
  {
    name: "MongoDB",
    percentage: 72,
  },
  {
    name: "Mysql",
    percentage: 75,
  },
  {
    name: "Photoshop",
    percentage: 80,
  },
  {
    name: "Illustrator",
    percentage: 70,
  },
  {
    name: "inDesign",
    percentage: 70,
  },
  {
    name: "Figma",
    percentage: 80,
  },
];

export default function Skills() {
  return (
    <div className="w-full min-h-[550px] lg:min-h-[240px] md:min-h-[320px] h-auto py-5" id="skills">
      <div
        className="py-10 mx-5 lg:mx-20 bg-[#131315] rounded-3xl h-full flex flex-col gap-6"
        data-aos="zoom-in"
      >
        <div
          className="text-xl h-10 text-center flex justify-center items-center"
          data-aos="zoom-in"
        >
          <h1 className="font-Poppins font-medium text-slate-400 ">
            MY SKILLS
          </h1>
        </div>
        <div className="flex justify-evenly gap-6 flex-wrap mx-2">
          {skills.map((skill, index) => (
            <div
              className="w-20 h-20 flex justify-center items-center flex-col"
              data-aos="zoom-out"
            >
              <Circle
                percent={skill.percentage}
                strokeWidth={10}
                trailColor="#2E3340"
                strokeColor="#3aa1ff"
                steps={10}
                space={4}
              />

              <h3
                className="text-[#f1edfd] font-Poppins text-xs lg:text-sm pt-2"
                key={index}
              >
                {skill.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
